import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-eb0ab3a6")

_pushScopeId("data-v-eb0ab3a6")
const _hoisted_1 = { class: "pt-16 fixed inset-0 overflow-y-auto z-10 overflow-scroll" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_default_button = _resolveComponent("default-button")
  const _component_BoostpackSubscribeCheckout = _resolveComponent("BoostpackSubscribeCheckout")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showButton === true)
      ? (_openBlock(), _createBlock(_component_default_button, {
          key: 0,
          "button-text": _ctx.$t('modal.SubscribeDialog.subscribeTitle'),
          "button-color": "bg-bp-light",
          "button-hover": "hover:bg-bp-light",
          "button-width": "auto",
          "button-x-margin": "mx-auto",
          onClick: _ctx.showDialog
        }, null, 8, ["button-text", "onClick"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_BoostpackSubscribeCheckout, {
        onCloseCheckout: _ctx.cancelDialog,
        visible: _ctx.dialogVisible,
        "boostpack-id": _ctx.propBoostpackId
      }, null, 8, ["onCloseCheckout", "visible", "boostpack-id"])
    ], 512), [
      [_vShow, _ctx.dialogVisible]
    ])
  ], 64))
})